import Contacts from '../../../assets/contacts.svg';

const ContactsIcon = (props: React.SVGProps<SVGSVGElement> & { disabled?: boolean }): JSX.Element => {
  return <Contacts fill={props.disabled ? '#868A90' : 'white'} {...props} />;
};

export default ContactsIcon;
